module.exports = __webpack_public_path__ + "static/media/carrying-handle.fde47378.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/carrying-handle.png
// module id = 1218
// module chunks = 0